export default {"src":"/_next/static/media/down-blue-arrow.7d6bafdd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};